import React from 'react'
import classnames from 'classnames'
import Seo from 'components/seo'
import Link from 'components/Base/Link'
import Layout from 'layouts/zh'
import Button, { ButtonGroup } from 'components/Base/Button'
import Card, { CardGroup } from 'components/Base/Card'
import SolutionsBanner from 'components/SolutionsBanner'
import SectionContent, { SectionHeaderMobile, SectionContentTypes } from 'components/SectionContent'
import SolutionsSwiper from 'components/SolutionsSwiper'
import SolutionsSwiperMobile from 'components/SolutionsSwiperMobile'
import { MediaSwiper } from 'components/MediaCard'
import ClientContent, { ClientTypes } from 'components/CustomerTestimony'
import StructureImage from 'components/StructureImage'
import { MaterialSwiper } from 'components/MaterialCard'
import Scheme, { SchemeSwiper } from 'components/Scheme'
import ScanCodeConsultButton from 'components/ScanCodeConsultButton'
import PageBottomCard from 'components/PageBottomCard'

import 'styles/base.less'
import * as styles from './index.module.less'

import banner from 'assets/images/solution/iptv/zh/banner-icon.png'

const materialList = [
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_01.png').default,
    title: '科学布局 A/B 测试',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=4015',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_02.png').default,
    title: 'IPTV 用户智能运营之道',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=3809',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_03.png').default,
    title: '玩转智能推荐 驱动业务增长',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=3603',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_04.png').default,
    title: '后广告时代数据助力融合媒体用户收入增长',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=3291',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_05.png').default,
    title: '打造数字化运营闭环，赋能融合媒体智能升级',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=2798',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_06.png').default,
    title: '融合媒体行业内容智能化推荐',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=2879',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_07.png').default,
    title: '广电大屏端数据驱动用户价值挖掘',
    href: 'https://www.sensorsdata.cn/market/playback-detail.html?id=2956',
    buttonText: '免费观看课程',
  },
  {
    imgSrc: require('assets/images/solution/iptv/zh/material_08.png').default,
    title: '用户中台建设实践解析',
    href: 'https://www.sensorsdata.cn/school/library/6ae11e9374e56d4040e38ef748d54497',
    buttonText: '免费观看课程',
  },
]

const Iptv: React.FC = (props) => {
  return (
    <Layout {...props}>
      <IptvState />
    </Layout>
  )
}

const IptvState: React.FC = (props) => {
  const demoUrl = '/doIPTV?formpage_source2=融媒大屏'
  const paradeUrl = '/form/parade.html?formpage_source2=融媒大屏'

  return (
    <>
      <Seo
        title="融合媒体｜以用户为中心的数据平台-神策数据解决方案"
        description="神策数据融合媒体解决方案，致力于打造以用户为中心的数据平台，通过大数据分析、用户运营、用户画像构建以及内容智能推荐，帮助智能大屏和移动端媒体完成数字化转型，加速传统媒体与新媒体融合发展。"
        keywords="融合媒体解决方案,数字化转型,IPTV,智能大屏,移动端媒体"
        saTitle="首页-产品（行业解决方案）-融合媒体"
      />
      <main className={styles.IptvState}>
        <SolutionsBanner
          className={styles.IptvBanner}
          title="融合媒体智能大屏解决方案"
          subTitle="智慧媒体大数据策略平台，科技赋能广电多元化经营"
          desc="打造以用户为中心的智慧媒体大数据策略平台，提升 IPTV 长效、核心竞争力。"
          imgUrl={<img src={banner} alt="" />}
          buttonGroup={
            <ButtonGroup>
              <Button href={demoUrl} target="_blank">
                体验智能大屏 Demo
              </Button>
            </ButtonGroup>
          }
          mobileHideIcon
          mobileHideButton
          mobileHideDesc
        />
        <NavMenu
          menus={[
            {
              url: '/solutions/iptv.html',
              name: '智能大屏解决方案',
              isActive: true,
            },
            {
              url: '/solutions/iptvMobile.html',
              name: '移动端解决方案',
            },
          ]}
        />
        <SectionContent title="智慧媒体大数据策略平台" type={SectionContentTypes.UseSectionHeaderMobile}>
          <SectionHeaderMobile title="智慧媒体大数据策略平台" />
          <SolutionsSwiper
            className={styles.SolutionsSwiper}
            dataSource={[
              {
                className: 'feature-01',
                icon: 'output',
                tabText: <>实时化数据分析</>,
                title: '实时化数据分析',
                imgUrl: require('assets/images/solution/iptv/zh/feature_01.png').default,
                imgWidth: 751,
                descList: [
                  {
                    title: '推荐位运营',
                    list: ['多维下钻洞察推荐位转化效果，内容运营心中有数'],
                  },
                  {
                    title: '订购归因',
                    list: ['回溯最近一次推荐位点击，全面了解各推荐位转化与贡献，提升流量变现价值'],
                  },
                  {
                    title: '续订分析',
                    list: ['产品多次续订一并分析，多指标多维度深入了解'],
                  },
                  {
                    title: '可视化数据看板',
                    list: ['EPG 点击热力图，直观洞察用户点击情况'],
                  },
                ],
                buttonList: [
                  {
                    text: '智能大屏 Demo',
                    href: demoUrl,
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-02',
                icon: 'user-operation',
                tabText: <>自动化用户运营</>,
                title: '自动化用户运营',
                imgUrl: require('assets/images/solution/iptv/zh/feature_02.png').default,
                imgWidth: 751,
                descList: [
                  {
                    title: '套餐订购运营',
                    list: ['筛选合适的目标用户，并自动推送活动内容（优惠券、折扣券），实时监控效果，及时调整策略'],
                  },
                  {
                    title: '流失用户运营',
                    list: ['为长期未登录用户推送近期热片，促使其开机观看'],
                  },
                ],
                buttonList: [
                  {
                    text: '智能大屏 Demo',
                    href: demoUrl,
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-03',
                icon: 'user-insight',
                tabText: <>个性化用户洞察</>,
                title: '个性化用户洞察',
                imgUrl: require('assets/images/solution/iptv/zh/feature_03.png').default,
                imgWidth: 751,
                descList: [
                  {
                    title: '体系化标签画像',
                    list: ['根据用户的观影习惯、收视偏好、订购情况等，打造标签画像体系，深度洞察用户'],
                  },
                  {
                    title: '赋能个性化运营',
                    list: ['根据标签画像洞察，赋能用户订购转化、个性化推送、流失召回等运营场景'],
                  },
                ],
                buttonList: [
                  {
                    text: '智能大屏 Demo',
                    href: demoUrl,
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
              {
                className: 'feature-03',
                icon: 'content-recommend',
                tabText: <>智能化内容推荐</>,
                title: '智能化内容推荐',
                imgUrl: require('assets/images/solution/iptv/zh/feature_04.png').default,
                imgWidth: 751,
                descList: [
                  {
                    title: '智能推荐方案',
                    list: ['以效果提升为交付目标，打造“数据-算法-效果-优化”一站式的闭环推荐方案'],
                  },
                  {
                    title: '三维智能推荐方案',
                    list: ['在合适的时间给合适的用户推荐合适的内容'],
                  },
                  {
                    title: '提升用户观影体验、订购转化率等',
                    list: ['基于海量数据和算法模型，给用户看到其感兴趣的媒资内容，提升用户粘性及订购转化率'],
                  },
                  {
                    title: '探索媒资内容的长尾价值',
                    list: ['通过推荐 3.0，利用向量的方式优化匹配内容与用户的算法，提高优质内容的曝光率'],
                  },
                ],
                buttonList: [
                  {
                    text: '智能大屏 Demo',
                    href: demoUrl,
                    target: '_blank',
                    type: 'primary',
                  },
                ],
              },
            ]}
          />
          {/* 移动端 */}
          <SolutionsSwiperMobile
            className={styles.SolutionsSwiperMobile}
            dataSource={[
              {
                title: '实时化数据分析',
                imgUrl: require('assets/images/solution/iptv/zh/feature_01.png').default,
              },
              {
                title: '自动化用户运营',
                imgUrl: require('assets/images/solution/iptv/zh/feature_02.png').default,
              },
              {
                title: '个性化用户洞察',
                imgUrl: require('assets/images/solution/iptv/zh/feature_03.png').default,
              },
              {
                title: '智能化内容推荐',
                imgUrl: require('assets/images/solution/iptv/zh/feature_04.png').default,
              },
            ]}
          />
          <ButtonGroup className={styles.SolutionsSwiperButton}>
            <Button btnType="primary" href={demoUrl}>
              智能大屏 Demo
            </Button>
          </ButtonGroup>
          <MediaSwiper
            className={styles.MediaSwiper}
            allowTouchMove={false}
            dataSource={[
              {
                url: 'https://www.sensorsdata.cn/school/library/b2fce1f828c83165fb283debcb7c9ac4',
                img: require('assets/images/solution/iptv/zh/media-01.png').default,
                imgMobile: '',
                alt: '',
              },
            ]}
          />
        </SectionContent>
        <SectionContent
          className={styles.MaterialContainerMobile}
          title="可落地的行业实践资料"
          type={SectionContentTypes.UseSectionHeaderMobile}
        >
          <SectionHeaderMobile title="可落地的行业实践资料" />
          <CardGroup className={styles.MaterialBookWrap}>
            <Card className={styles.BookCard} title="《存量经营时代：数据驱动 IPTV/OTT 精细化运营》" bordered={false}>
              <a href="https://www.sensorsdata.cn/school/library/b2fce1f828c83165fb283debcb7c9ac4">
                <img
                  className={styles.BookThumb}
                  src={require('assets/images/solution/iptv/zh/book-thumb.png').default}
                  alt=""
                />
              </a>
            </Card>
          </CardGroup>
          <MaterialSwiper className={styles.MaterialSwiper} dataSource={materialList} />
        </SectionContent>
        <SectionContent
          title="众多行业客户服务经验"
          className={styles.ClientContainer}
          type={SectionContentTypes.UseSectionHeaderMobile}
        >
          <SectionHeaderMobile title="众多行业客户服务经验" />
          <ClientContent
            type={ClientTypes.Type20211220}
            className={styles.ClientWrap}
            abstract={
              <>
                神策数据融合媒体事业部已服务 20 余家融媒行业客户，其中省级广电机构超过 10 家。涵盖了
                OTT、IPTV、有线电视、广电报业融媒体以及图书出版等细分赛道。
                <br />
                神策数据推出的“智能广电大数据策略平台”获得北京市广播电视局“2021
                年度媒体融合创新技术与服务应用优秀推荐项目”，并通过大数据产业生态联盟“第十期优秀大数据解决方案和应用案例评测”。
              </>
            }
          >
            <div className="text-center">
              <img
                className="max-w-[1000px] hidden lg:inline"
                src="https://ow-file.sensorsdata.cn/www/solutions/iptv/iptv_logo.png"
                alt=""
              />
              <p className="lg:pt-[40px] pt-[2rem]">
                <Button href={demoUrl} target="_blank" btnType="primary">
                  智能大屏 Demo
                </Button>
              </p>
            </div>
          </ClientContent>
        </SectionContent>
        <SectionContent className={styles.MaterialContainer} title="可落地的行业实践资料" backgroundColor="#F5FBFF">
          <MaterialSwiper className={styles.MaterialSwiper} dataSource={materialList} />
        </SectionContent>
        <SectionContent className={styles.StructureContainer} title="智慧媒体大数据策略平台架构图">
          <StructureImage
            className={styles.StructureImage}
            src={require('assets/images/solution/iptv/zh/structure-image.png').default}
            width={1009}
          />
          <div className={styles.StructureButtonWrap}>
            <ScanCodeConsultButton
              buttonText="扫码咨询方案顾问"
              qrcode={require('assets/images/solution/game/panorama_code.png').default}
            />
          </div>
        </SectionContent>
        <SchemeContainer />
        <PageBottomCard
          title="打造以用户为中心的智慧媒体大数据策略平台！"
          desc="立即预约，快速找到适合您的智能大屏解决方案！"
          leftButtonText="体验智能大屏 Demo"
          leftButtonHref={demoUrl}
          rightButtonText="预约演示"
          rightButtonHref={paradeUrl}
        />
      </main>
    </>
  )
}

interface SchemeContainerProps {
  className?: string
}
export const SchemeContainer: React.FC<SchemeContainerProps> = (props) => {
  const { className } = props
  return (
    <SectionContent
      className={classnames(styles.SchemeContainer, className)}
      title="方案优势"
      type={SectionContentTypes.UseSectionHeaderMobile}
      backgroundColor="#F5FBFF"
    >
      <SectionHeaderMobile title="方案优势" />
      <Scheme
        className={styles.SchemeWrap}
        columnNum={4}
        dataSource={[
          {
            title: '产品强大',
            desc: '数据基础能力强，提供多元化分析维度，产品成熟度高、更新迭代快',
            icon: require('assets/images/solution/iptv/zh/scheme-01.svg').default,
            alt: 'icon',
          },
          {
            title: '方案闭环',
            desc: '全流程整体解决方案，基于 SDAF 数字化运营方法论，可一站式满足精细化运营全场景',
            icon: require('assets/images/solution/iptv/zh/scheme-02.svg').default,
            alt: 'icon',
          },
          {
            title: '服务优质',
            desc: '高服务质量，咨询和实施交付能力强，响应快、协同效率高，可长期陪伴式服务',
            icon: require('assets/images/solution/iptv/zh/scheme-03.svg').default,
            alt: 'icon',
          },
          {
            title: '经验丰富',
            desc: '深耕大数据营销科技领域和融媒领域，大量互联网行业服务经验赋能融媒行业',
            icon: require('assets/images/solution/iptv/zh/scheme-04.svg').default,
            alt: 'icon',
          },
        ]}
      />
      <SchemeSwiper
        className={styles.SchemeWrapMobile}
        dataSource={[
          {
            title: '产品强大',
            desc: '数据基础能力强，提供多元化分析维度，产品成熟度高、更新迭代快',
            icon: require('assets/images/solution/iptv/zh/scheme-01.svg').default,
            alt: 'icon',
          },
          {
            title: '方案闭环',
            desc: '全流程整体解决方案，基于 SDAF 数字化运营方法论，可一站式满足精细化运营全场景',
            icon: require('assets/images/solution/iptv/zh/scheme-02.svg').default,
            alt: 'icon',
          },
          {
            title: '服务优质',
            desc: '高服务质量，咨询和实施交付能力强，响应快、协同效率高，可长期陪伴式服务',
            icon: require('assets/images/solution/iptv/zh/scheme-03.svg').default,
            alt: 'icon',
          },
          {
            title: '经验丰富',
            desc: '深耕大数据营销科技领域和融媒领域，大量互联网行业服务经验赋能融媒行业',
            icon: require('assets/images/solution/iptv/zh/scheme-04.svg').default,
            alt: 'icon',
          },
        ]}
      />
    </SectionContent>
  )
}

interface NavMenuItemProps {
  url: string
  name: string
  isActive?: boolean
}
interface NavMenuProps {
  className?: string
  menus?: NavMenuItemProps[]
}
export const NavMenu: React.FC<NavMenuProps> = (props) => {
  const { menus, className } = props
  return (
    <nav className={classnames(styles.NavMenu, className)}>
      <ul>
        {menus?.map((item) => (
          <li key={item.url} className={classnames({ [styles.active]: item.isActive })}>
            <Link to={item.url}>{item.name}</Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Iptv
